import Comp from './ResetPasswordPage';

export default Comp;
